/**
 * StreamBinding entity class
 */

/**
 * StreamBindingFactory
 * returns StreamBinding entity class
 *
 * @class StreamBindingFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.StreamBinding} class
 *
 * @ngdoc factory
 * @name mwApp.factory:StreamBindingFactory
 */
/* @ngInject */
export default function StreamBindingFactory (Entity) {
  /* === StreamBinding class === */

  /**
   * StreamBinding model
   *
   * @class StreamBinding
   * @classdesc StreamBinding model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @return {models.StreamBinding} StreamBinding entity
   */
  function StreamBinding () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  StreamBinding.prototype = Object.create(Entity.prototype)
  StreamBinding.prototype.constructor = StreamBinding

  /* === StreamBinding instance methods & fields === */

  Object.assign(StreamBinding.prototype, {
    /**
     * instance fields
     *
     * @memberof models.StreamBinding#
     * @type {Object}
     */
    _fields: {
      id: Number,
      streamId: String,
      streamName: String,
      server: {
        id: Number
      }
    }
  })

  /* === StreamBinding static methods & fields === */

  Object.assign(StreamBinding, Entity)
  StreamBinding._name = 'StreamBinding'
  StreamBinding.init()

  return StreamBinding
}
